import { render, staticRenderFns } from "./GridHome.vue?vue&type=template&id=eb6c343a&scoped=true&"
import script from "./GridHome.vue?vue&type=script&lang=ts&"
export * from "./GridHome.vue?vue&type=script&lang=ts&"
import style0 from "./GridHome.vue?vue&type=style&index=0&id=eb6c343a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6c343a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('eb6c343a', component.options)
    } else {
      api.reload('eb6c343a', component.options)
    }
    module.hot.accept("./GridHome.vue?vue&type=template&id=eb6c343a&scoped=true&", function () {
      api.rerender('eb6c343a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/GridHome.vue"
export default component.exports